import { render } from "./QualityChecklist.vue?vue&type=template&id=71b20ae8"
import script from "./QualityChecklist.vue?vue&type=script&lang=js"
export * from "./QualityChecklist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__